export default "__VITE_ASSET__CpxtTRiz__"